import { EventTypeProcess } from './EventTypeProcess';

export class EventTypeProcessOverview {
    constructor(evTypePrcList: EventTypeProcess[]) {
        this.evTypePrcList = evTypePrcList;
    }
    evTypePrcList: EventTypeProcess[];
}
